import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const BoutonModifyGroupName = ({ label, onClick, disabled = false }) => {
  return (
    <Tooltip title={label} arrow>
      <span
        style={{
          pointerEvents: disabled ? "none" : "auto",
          opacity: disabled ? 0.5 : 1,
          display: "inline-block"
        }}
      >
    <IconButton
      onClick={onClick}
      disabled={disabled}
      aria-label={label} // accessibilité
      sx={{
        minWidth: "auto",
        padding: 1,
        backgroundColor: "transparent",
        borderColor: "transparent",
        borderRadius: "50%",
        boxShadow: "none",
        '&:hover': {
          backgroundColor: "transparent",
          color: "#f0f0f0"   
        },
      }}
    >
      <EditIcon
      sx={{ 
        fontSize: "2rem", 
        color: "#71685e !important",  // ✅ blanc pur
        width: "2rem",      // ✅ force largeur
        height: "3rem",     // ✅ force hauteur
        display: "block"    // ✅ évite la compression par l’inline
        }}/>
    </IconButton>
    </span>
    </Tooltip>
  );
};

export default BoutonModifyGroupName;
